<span *ngIf="orgHasWorkspaces" fxLayoutAlign="center" class="workspace-nav">
  <button
    mat-button
    [matMenuTriggerFor]="workspacesMenu"
    id="workspace-menu"
    class="workspace-nav-button"
    aria-label="Select workspace menu"
  >
    <div fxLayout="row" fxLayoutAlign="start center">
      <div>
        <span class="workspace-label">{{ activeWorkspaceName }}</span>
        <span *ngIf="isOrgWorkspace(activeWorkspace)" class="pill primary">ORG</span>
      </div>
      <mat-icon id="workspace-menu-action" class="push-right">arrow_drop_down</mat-icon>
    </div>
  </button>

  <mat-menu #workspacesMenu>
    <button
      class="workspace-nav-button"
      *ngFor="let ws of workspaces"
      (click)="selectWorkspace(ws)"
      attr.aria-label="Select {{ ws.name }} workspace"
      mat-menu-item
    >
      <div fxLayout="row" fxLayoutAlign="start center">
        <div>
          <mat-icon>subdirectory_arrow_right</mat-icon>
          <span class="workspace-label">{{ ws.name }}</span>
          <span *ngIf="isOrgWorkspace(ws)" class="pill accent">ORG</span>
        </div>
        <mat-icon *ngIf="isActiveWorkspace(ws)" class="push-right">check</mat-icon>
      </div>
    </button>
  </mat-menu>
</span>
